import axios from 'axios';

const updateLoadOrderAddresses = function () {
  axios
    .get('/contact_addresses', {
      params: { contact_id: $('#load_order_contact_id').val() },
    })
    .then((response) => {
      let address = $('#load_order_address');
      address.empty();
      $.each(response.data, function (_, addr) {
        address.append(new Option(addr));
      });
      address.trigger('change');
    })
    .catch((error) => {
      console.log(error.response.data);
    });
};

document.addEventListener('turbolinks:load', function () {
  $('#load_order_contact_id').on('change', updateLoadOrderAddresses);
});
